import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import { AUTH_HEADER } from '@onefootprint/types';
import { useMutation } from '@tanstack/react-query';
type UserChallengeVerifyBody = {
  authToken: string;
  challengeResponse: string; // The response to the challenge. Either SMS/email PIN code or passkey response
  challengeToken: string; // The token given from initiating the challenge
};
type UserChallengeVerifyResponse = {};
const requestFn = async ({
  authToken,
  challengeResponse,
  challengeToken
}: UserChallengeVerifyBody) => {
  const headers: Record<string, string> = {
    [AUTH_HEADER]: authToken
  };
  const response = await request<UserChallengeVerifyResponse>({
    method: 'POST',
    url: '/hosted/user/challenge/verify',
    headers,
    data: {
      challengeResponse,
      challengeToken
    }
  });
  return response.data;
};
const useUserChallengeVerify = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: requestFn
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useUserChallengeVerify;